export namespace ContactTypesStatic {
  export interface ContactType {
    id: number;
    name: string;
  }

  export enum ContactTypeSearchParameters { name = 'name' }
}
